const cols = [
  {
    heading: "Platform",
    links: ["About", "Features", "Vision", "Team"],
  },
  {
    heading: "Values",
    links: ["Confidential", "Anonymous", "Moderated", "Safeguarded"],
  },
];

export const Footer = () => {
  return (
    <footer
      className="bg-foreground text-background px-6 md:px-12 pt-20 pb-10"
      data-testid="footer"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-background/15">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-background">
                <span className="h-2.5 w-2.5 rounded-full bg-accent" />
              </span>
              <span className="font-serif text-2xl tracking-tight">
                Kel<span className="italic">Calm</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-background/70 leading-relaxed font-serif italic text-xl">
              A safe space, always open for you.
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.heading} className="md:col-span-2">
              <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-background/50 mb-5">
                {c.heading}
              </h4>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l}>
                    <span className="text-background/80 hover:text-background transition-colors duration-300 cursor-default">
                      {l}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-background/50 mb-5">
              Reach out
            </h4>
            <a
              href="mailto:hello@kelcalm.org"
              data-testid="footer-email"
              className="text-background/80 hover:text-background transition-colors duration-300"
            >
              hello@kelcalm.org
            </a>
            <p className="mt-4 text-sm text-background/50 leading-relaxed">
              If you&apos;re in immediate crisis, please contact your local emergency services.
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-background/50">
          <p>© {new Date().getFullYear()} KelCalm. Made with care.</p>
          <p className="font-serif italic">Stay calm. Stay yourself.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
